import { TextoPagina } from "./pagina/TextoPagina";
import { Versao } from "./Versao";

export class TextoPaginaFunctions {
  static getVersao(texto: TextoPagina): Versao {
    return texto.versoes[texto.indexVersao];
  }
}
